import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getDealerById } from '@/lib/api';

const AuthContext = createContext({});

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [dealer, setDealer] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    setDealer(null);
    localStorage.removeItem('dealerId');
  }, []);

  const fetchDealer = useCallback(async (id) => {
    try {
      const res = await getDealerById(id);
      setDealer(res.data);
    } catch (error) {
      console.error('Error fetching dealer:', error);
      logout();
    } finally {
      setLoading(false);
    }
  }, [logout]);

  useEffect(() => {
    const dealerId = localStorage.getItem('dealerId');
    if (dealerId) {
      fetchDealer(dealerId);
    } else {
      setLoading(false);
    }
  }, [fetchDealer]);

  const login = async (dealerData) => {
    setDealer(dealerData);
    localStorage.setItem('dealerId', dealerData.id);
  };

  const value = {
    dealer,
    loading,
    login,
    logout,
    isAuthenticated: !!dealer,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
